import basics_artefact from "../img/Basics/Basics_Artefact.png"
import basics_artefactUVMap from "../img/Basics/Basics_ArtefactUVMap.png"
import intro_checkerConeAuto from "../img/Intro/Intro_CheckerConeAuto.png"
import basics_checkerConeAutoMap from "../img/Basics/Basics_CheckerConeAutoMap.png"
import basics_checkerCone from "../img/Basics/Basics_CheckerCone.gif"
import basics_cylinderCut from "../img/Basics/Basics_CylinderCut.gif"
import basics_cylinderNoCut from "../img/Basics/Basics_CylinderNoCut.gif"
import basics_capsule from "../img/Basics/Basics_Capsule.png"
import basics_capsuleDecomp from "../img/Basics/Basics_CapsuleDecomp.png"
import basics_compoundStep1 from "../img/Basics/Basics_Compound_Step1.png"
import basics_compoundStep2 from "../img/Basics/Basics_Compound_Step2.png"
import basics_compoundUVStep1 from "../img/Basics/Basics_CompoundUV_Step1.png"
import basics_compoundUVStep2 from "../img/Basics/Basics_CompoundUV_Step2.png"
import basics_icoStep1 from "../img/Basics/Basics_Ico_Step1.png"
import basics_icoStep2 from "../img/Basics/Basics_Ico_Step2.png"
import basics_icoUVStep1 from "../img/Basics/Basics_IcoUV_Step1.png"
import basics_icoUVStep2 from "../img/Basics/Basics_IcoUV_Step2.png"
import basics_overlap from "../img/Basics/Basics_Overlap.png"
import basics_overlapUV from "../img/Basics/Basics_OverlapUV.png"
import basics_paddingUV from "../img/Basics/Basics_PaddingUV.png"
import basics_paddingUVLowRes from "../img/Basics/Basics_PaddingUV_LowRes.png"
import { Trans, useTranslation } from "react-i18next"
import { ReadingProgressBar } from "../components/ReadingProgressBar"
import { BackToTopButton } from "../components/BackToTopButton"
import { TableOfContents } from "../components/TableOfContents"

export function PageBasics() {
    const {t} = useTranslation("pageBasics");

    const sections = [
        { id: "understanding-artifacts", title: t("firstTitle") },
        { id: "why-seams", title: t("secondTitle") },
        { id: "choosing-seams", title: t("thirdTitle") },
        { id: "shape-breakdown", title: t("fourthTitle") },
        { id: "sew-and-cut", title: t("fifthTitle") },
        { id: "uv-shells", title: t("sixthTitle") },
        { id: "practice", title: t("practiceTitle") },
        { id: "summary", title: t("seventhTitle") },
        { id: "glossary", title: t("glossaryTitle") },
    ];

    return (
      <>
        <ReadingProgressBar />
        <TableOfContents sections={sections} />
        <div className="page">
          <h1>{t("basics")}</h1>
          <h2 id="understanding-artifacts">{t("firstTitle")}</h2>
              <div className="sectionParagraphe-column">
                  <Trans><p>{t("reminderSeams")}</p></Trans>
                  <div className="img-wrapper">
                      <figure className ="img-card">
                          <img src={basics_artefact} alt="Cone with texture artefact (seam)"></img>
                          <figcaption>{t("coneSeamArtifact")}</figcaption>
                      </figure>
                      <figure className ="img-card">
                          <img src={basics_artefactUVMap} alt="UVMap of cone with texture artefact (seam)"></img>
                          <figcaption>{t("coneSeamArtifactUV")}</figcaption>
                      </figure>
                  </div>
                  <Trans><p>{t("faceArtifacts")}</p></Trans>
              </div>
              <div className="sectionParagraphe-column">
                  <Trans><p>{t("stretchArtifacts")}</p></Trans>
                  <div className="img-wrapper">
                      <figure className ="img-card">
                          <img src={intro_checkerConeAuto} alt="Cone with texture artefact (stretch)"></img>
                          <figcaption>{t("coneStretchArtifact")}</figcaption>
                      </figure>
                      <figure className ="img-card">
                          <img src={basics_checkerConeAutoMap} alt="UVMap of cone with texture artefact (stretch)"></img>
                          <figcaption>{t("coneStretchArtifactUV")}</figcaption>
                      </figure>
                      <figure className ="img-card">
                          <img src={basics_checkerCone} alt="Animated cone with texture artefact (stretch)"></img>
                          <figcaption>{t("coneStretchArtifactGIF")}</figcaption>
                      </figure>
                  </div>
              </div>

          <h2 id="why-seams">{t("secondTitle")}</h2>
              <div className="sectionParagraphe-column">
                  <p>{t("whySeams")}</p>
                  <div className="img-wrapper">
                      <figure className ="img-card">
                          <img src={basics_cylinderCut} alt="Cylinder with seam"></img>
                          <figcaption>{t("cylinderSeam")}</figcaption>
                      </figure>
                      <figure className ="img-card">
                          <img src={basics_cylinderNoCut} alt="Cylinder without seam"></img>
                          <figcaption>{t("cylinderNoSeam")}</figcaption>
                      </figure>
                  </div>
                  <div className="information">
                      <p>{t("sphereDeform")}</p>
                  </div>
              </div>


          <h2 id="choosing-seams">{t("thirdTitle")}</h2>
              <div className="sectionParagraphe-column">
                  <p>{t("chooseSeams")}</p>
                  <div className="important">
                      <ul>
                          <li>{t("minSeams")}</li>
                          <li>{t("minStretch")}</li>
                          <li>{t("hiddenSeams")}</li>
                      </ul>
                  </div>
                  <div className="information">
                      <h4>{t("hiddenSeamsTipsTitle")}</h4>
                      <ul>
                          <li><Trans>{t("hiddenSeamsTip1")}</Trans></li>
                          <li><Trans>{t("hiddenSeamsTip2")}</Trans></li>
                          <li><Trans>{t("hiddenSeamsTip3")}</Trans></li>
                          <li><Trans>{t("hiddenSeamsTip4")}</Trans></li>
                          <li><Trans>{t("hiddenSeamsTip5")}</Trans></li>
                          <li><Trans>{t("hiddenSeamsTip6")}</Trans></li>
                      </ul>
                      <p><em>{t("hiddenSeamsQuestion")}</em></p>
                  </div>
              </div>

          <h2 id="shape-breakdown">{t("fourthTitle")}</h2>
              <div className="sectionParagraphe-column">
                  <Trans><p>{t("breakdownContent")}</p></Trans>
                  <div className="img-wrapper">
                      <figure className ="img-card">
                          <img src={basics_capsule} alt="Capsule"></img>
                          <figcaption>{t("capsule")}</figcaption>
                      </figure>
                      <figure className ="img-card">
                          <img src={basics_capsuleDecomp} alt="Capsule decomposition"></img>
                          <figcaption>{t("capsuleBreakdown")}</figcaption>
                      </figure>
                  </div>
                  <div className="important">
                      <p>{t("breakdownShell")}</p>
                  </div>
              </div>
              <div className="sectionParagraphe-column">
                  <h4>{t("realWorldTitle")}</h4>
                  <p>{t("realWorldIntro")}</p>
                  <ul>
                      <li><Trans>{t("realWorldBarrel")}</Trans></li>
                      <li><Trans>{t("realWorldHead")}</Trans></li>
                      <li><Trans>{t("realWorldBuilding")}</Trans></li>
                  </ul>
                  <div className="information">
                      <p>{t("realWorldNote")}</p>
                  </div>
              </div>

          <h2 id="sew-and-cut">{t("fifthTitle")}</h2>
              <div className="sectionParagraphe-column">
                  <div className="information">
                  <Trans><p>{t("sewCutInfo")}</p></Trans>
                  </div>
                  <p>{t("sewCutWorkflows")}</p>
              </div>

              <div className="sectionParagraphe-column">
                  <p><b>{t("workflowCut")}</b></p>
                  <ul>
                      <li>{t("workflowCutList1")}</li>
                      <li>{t("workflowCutList2")}</li>
                      <li>{t("workflowCutList3")}</li>
                      <li>{t("workflowCutList4")}</li>
                  </ul>

                  <div className="img-wrapper">
                      <figure className ="img-card">
                          <img src={basics_compoundStep1} alt="Lego - Step 1"></img>
                          <figcaption>{t("legoStep1")}</figcaption>
                      </figure>
                      <figure className ="img-card">
                          <img src={basics_compoundUVStep1} alt="Lego UV - Step 1"></img>
                          <figcaption>{t("legoStep1UV")}</figcaption>
                      </figure>
                  </div>
                  <div className="img-wrapper">
                      <figure className ="img-card">
                          <img src={basics_compoundStep2} alt="Lego - Step 2"></img>
                          <figcaption>{t("legoStep2")}</figcaption>
                      </figure>
                      <figure className ="img-card">
                          <img src={basics_compoundUVStep2} alt="Lego UV - Step 2"></img>
                          <figcaption>{t("legoStep2UV")}</figcaption>
                      </figure>
                  </div>

              </div>
              <div className="sectionParagraphe-column">
                  <p><b>{t("workflowSew")}</b></p>
                      <ul>
                          <li>{t("workflowSewList1")}</li>
                          <li>{t("workflowSewList2")}</li>
                          <li>{t("workflowSewList3")}</li>
                      </ul>

                  <div className="img-wrapper">
                      <figure className ="img-card">
                          <img src={basics_icoStep1} alt="Icosphere - Step 1"></img>
                          <figcaption>{t("icoStep1")}</figcaption>
                      </figure>
                      <figure className ="img-card">
                          <img src={basics_icoUVStep1} alt="Icosphere UV - Step 1"></img>
                          <figcaption>{t("icoStep1UV")}</figcaption>
                      </figure>
                  </div>

                  <div className="img-wrapper">
                      <figure className ="img-card">
                          <img src={basics_icoStep2} alt="Icosphere - Step 2"></img>
                          <figcaption>{t("icoStep2")}</figcaption>
                      </figure>
                      <figure className ="img-card">
                          <img src={basics_icoUVStep2} alt="Icosphere UV - Step 2"></img>
                          <figcaption>{t("icoStep2UV")}</figcaption>
                      </figure>
                  </div>
              </div>
              <div className="sectionParagraphe-column">
              <p>{t("multipleWorkflows")}</p>
                  <div className="information">
                      <p>{t("justTry")}</p>
                  </div>

              </div>


          <h2 id="uv-shells">{t("sixthTitle")}</h2>
              <div className="sectionParagraphe-column">
                  <p>{t("uvShellContent")}</p>
                  <div className="img-wrapper">
                      <figure className ="img-card">
                          <img src={basics_overlap} alt="Cone with overlapping UV islands"></img>
                          <figcaption>{t("overlapCone")}</figcaption>
                      </figure>
                      <figure className ="img-card">
                          <img src={basics_overlapUV} alt="UV Map of a cone with overlapping UV islands"></img>
                          <figcaption>{t("overlapConeUV")}</figcaption>
                      </figure>
                  </div>
              </div>
              <div className="sectionParagraphe-column">
                  <div className="important">
                      <h4>{t("uvSpaceTitle")}</h4>
                      <p>{t("uvSpaceContent")}</p>
                      <ul>
                          <li>{t("uvSpaceInside")}</li>
                          <li><Trans>{t("uvSpaceOutside")}</Trans></li>
                      </ul>
                      <p>{t("uvSpaceNote")}</p>
                  </div>
              </div>
              <div className="sectionParagraphe-column">
                  <Trans><p>{t("padding")}</p></Trans>
                  <div className="img-wrapper">
                      <figure className ="img-card">
                          <img src={basics_paddingUV} alt="UV Map of a cone with no padding on UV islands"></img>
                          <figcaption>{t("noPaddingCone")}</figcaption>
                      </figure>
                      <figure className ="img-card">
                          <img src={basics_paddingUVLowRes} alt="Low resolution UV Map of a cone with no padding on UV islands"></img>
                          <figcaption>{t("noPaddingConeLowRes")}</figcaption>
                      </figure>
                  </div>
                  <p>{t("lod")}</p>
                  <div className="information">
                      <p>{t("infoShell")}</p>
                  </div>
              </div>
              <div className="sectionParagraphe-column">
                  <h4>{t("texelDensityTitle")}</h4>
                  <p>{t("texelDensityContent")}</p>
                  <Trans><p>{t("texelDensityExample")}</p></Trans>
                  <Trans><p>{t("texelDensityRule")}</p></Trans>
                  <div className="information">
                      <p>{t("texelDensityNote")}</p>
                  </div>
              </div>

          <h2 id="practice">{t("practiceTitle")}</h2>
              <div className="sectionParagraphe-column">
                  <p>{t("practiceIntro")}</p>
                  <div className="important">
                      <h4>{t("practiceInterfaceTitle")}</h4>
                      <ul>
                          <li><Trans>{t("practiceInterface1")}</Trans></li>
                          <li><Trans>{t("practiceInterface2")}</Trans></li>
                          <li><Trans>{t("practiceInterface3")}</Trans></li>
                      </ul>
                  </div>
                  <div className="important">
                      <h4>{t("practiceHowTitle")}</h4>
                      <ol>
                          <li><Trans>{t("practiceHow1")}</Trans></li>
                          <li><Trans>{t("practiceHow2")}</Trans></li>
                          <li><Trans>{t("practiceHow3")}</Trans></li>
                          <li><Trans>{t("practiceHow4")}</Trans></li>
                      </ol>
                  </div>
                  <div className="information">
                      <h4>{t("practiceGoalsTitle")}</h4>
                      <ul>
                          <li><Trans>{t("practiceGoals1")}</Trans></li>
                          <li><Trans>{t("practiceGoals2")}</Trans></li>
                      </ul>
                      <p>{t("practiceGoalsNote")}</p>
                  </div>
              </div>

          <h2 id="summary">{t("seventhTitle")}</h2>
              <div className="sectionParagraphe-column centered">
                  <p>{t("multipleSolutions")}</p>
                  <div className="important">
                      <ul>
                          <li>{t("minSeams")}</li>
                          <li>{t("minStretch")}</li>
                          <li>{t("hiddenSeams")}</li>
                      </ul>
                  </div>
              </div>

          <h2 id="glossary">{t("glossaryTitle")}</h2>
              <div className="sectionParagraphe-column">
                  <div className="glossary">
                      <ul>
                          <li><Trans>{t("glossaryMesh")}</Trans></li>
                          <li><Trans>{t("glossaryVertex")}</Trans></li>
                          <li><Trans>{t("glossaryEdge")}</Trans></li>
                          <li><Trans>{t("glossaryFace")}</Trans></li>
                          <li><Trans>{t("glossarySeam")}</Trans></li>
                          <li><Trans>{t("glossaryUVMap")}</Trans></li>
                          <li><Trans>{t("glossaryShell")}</Trans></li>
                          <li><Trans>{t("glossaryUnwrap")}</Trans></li>
                          <li><Trans>{t("glossaryStretch")}</Trans></li>
                          <li><Trans>{t("glossaryTexel")}</Trans></li>
                          <li><Trans>{t("glossaryTexelDensity")}</Trans></li>
                          <li><Trans>{t("glossaryPadding")}</Trans></li>
                          <li><Trans>{t("glossaryArtifact")}</Trans></li>
                      </ul>
                  </div>
              </div>

              <a href="practice" className="nextButton"> {t("next")}</a>
          </div>
          <BackToTopButton />
      </>
    );
  }
